var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    { staticClass: "sub-menu md-3", attrs: { "slider-color": "primary" } },
    [
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/cost-centre", exact: "" }
        },
        [_vm._v(" " + _vm._s(_vm.$t("settings.costCentre.menu.list")) + " ")]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/cost-centre/users" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.costCentre.menu.userAssignment")) +
              " "
          )
        ]
      ),
      _c(
        "v-tab",
        {
          staticClass: "sub-menu-item",
          attrs: { to: "/settings/cost-centre/budget" }
        },
        [_vm._v(" " + _vm._s(_vm.$t("settings.costCentre.menu.budget")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }